//cost Modelling api services
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'
import { shouldCostLibraryApiRoutes } from 'src/constants/serviceConstants/costModelling.apiRoutes'

//get categories l1,l2,l3 data
export const getShouldCostFiltersAsync = createAsyncThunk(
  'api/should-cost-library/get-filter-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getShouldCostFilters, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get all should cost models
export const getShouldCostModelsByFiltersAsync = createAsyncThunk(
  'api/should-cost-library/get-should-cost-models-by-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes?.getShouldCostModelsByFilters,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get kpis data should cost library
export const getShouldCostKPIsAsync = createAsyncThunk(
  'api/should-cost-library/get-should-cost-kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getShouldCostKPIs, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete should cost model
export const deleteShouldCostModelAsync = createAsyncThunk(
  'api/should-cost-library/delete-should-cost-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.deleteShouldCostModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get view should cost specifications and attachments
export const getModelMetaDataAsync = createAsyncThunk(
  'api/should-cost-library/get-model-meta-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getModelMetaData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getShouldCostModelDetailsAsync = createAsyncThunk(
  'shouldCostAIBased/get-should-cost-model-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes.getShouldCostModelDetails,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get dpcd data
export const getDpcdDataAsync = createAsyncThunk(
  'api/should-cost-library/get-dpcd-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getDpcdData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCostComponentListAsync = createAsyncThunk(
  'api/should-cost-library/get-standard-cost-components-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', shouldCostLibraryApiRoutes.getCostComponentList, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get should cost breakdown data
export const getShouldCostBreakdownDataAsync = createAsyncThunk(
  'api/should-cost-library/getShouldCostBreakdownData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/should-cost-analysis/get-should-cost-breakdown',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get Commodity data
export const getCommodityDataAsync = createAsyncThunk(
  'api/should-cost-library/commodity-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getCommodityData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Commodity KPIs
export const getCommodityKPIsAsync = createAsyncThunk(
  'api/should-cost-library/commodity-kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getCommodityKPIs, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// save created sc model
export const saveShouldCostModelAsync = createAsyncThunk(
  'cost-modelling/saveShouldCostModelAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.saveCreatedModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get should cost breakdown data for model
export const getShouldCostModelBreakdownAsync = createAsyncThunk(
  'cost-modelling/getShouldCostModelBreakdownData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes.getShouldCostBreakdownForModel,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
// get should cost breakdown data for model
export const editShouldCostModelAsync = createAsyncThunk(
  'shouldCostAIBased/editShouldCostModel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.editCreatedModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get should cost breakdown data for model
export const getMiniIfaPreviewAsync = createAsyncThunk(
  'cost-modelling/get-mini-ifa-preview',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getMiniIfaDataPreview, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get should cost breakdown data for model
export const getBomAndChartPreviewAsync = createAsyncThunk(
  'cost-modelling/get-bom-and-chart-preview',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes?.getBomAndChartDataPreview,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// save as draft model
export const saveAsDraftModelAsync = createAsyncThunk(
  'api/should-cost-library/save-as-draft-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.saveAsDraftModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// preview download should cost model
export const previewDownloadShouldCostAsync = createAsyncThunk(
  'api/should-cost-library/preview-download-should-cost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes?.previewDownloadShouldCost,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get mini ifa for view papge
export const getMiniIfaAsync = createAsyncThunk(
  'api/should-cost-library/get-mini-ifa',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getMiniIfa, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get bom and chart for view page
export const getBomAndChartAsync = createAsyncThunk(
  'api/should-cost-library/get-bom-and-chart-',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getBomAndChart, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get total model count
export const getTotalModelsCountAsync = createAsyncThunk(
  'api/should-cost-library/get-total-models-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getTotalModelCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getPreviewMiniIFABomAsync = createAsyncThunk(
  '/cost-modelling/get-preview-mini-ifa-bom',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getPreviewMiniIFABom, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getMiniIfaV2Async = createAsyncThunk(
  '/cost-modelling/get-mini-ifa',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getMiniIfaV2, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getChartBomV2Async = createAsyncThunk(
  '/cost-modelling/get-bom',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getChartBomV2, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getHTSDetailsAsync = createAsyncThunk(
  '/cost-modelling/get-hts-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getHTSDetails, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const createTopDownModelAsync = createAsyncThunk(
  'cost-modelling/create-top-down-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.createTopDownModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const editTopDownModelAsync = createAsyncThunk(
  'shouldCostAIBased/edit-top-down-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.editTopDownModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getTopDownModelBreakdownAsync = createAsyncThunk(
  'cost-modelling/get-top-down-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getTopDownModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getModelMetaDataV2Async = createAsyncThunk(
  'api/should-cost-library/get-model-meta-data-v2',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getModelMetaDataV2, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDestinationCountryListAsync = createAsyncThunk(
  'cost-modelling/get-destination-country-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', shouldCostLibraryApiRoutes.getDestinationCountryList, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDpcdDataV2Async = createAsyncThunk(
  'cost-modelling/get-dpcd-data-v2',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.getDpcdDataV2, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const previewDownloadShouldCostV2Async = createAsyncThunk(
  'cost-modelling/preview-download-should-cost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes?.previewDownloadShouldCostV2,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const saveAsDraftTopDownModelAsync = createAsyncThunk(
  'shouldCostAIBased/save-as-draft-top-down-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes.saveAsDraftTopDownModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAIGeneratedBreakdownV2Async = createAsyncThunk(
  'cost-modelling/genai/breakdown-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      shouldCostLibraryApiRoutes?.getAIGeneratedBreakdownV2,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getFetchableUrlAsync = createAsyncThunk(
  'cost-modelling/get-fetchable-url',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', shouldCostLibraryApiRoutes?.getFetchableUrl, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
